import React from "react";

import moment from "moment";
import { orderBy } from "lodash";

import StyledScrollbar from "../../../../Common/UIComponents/StyledScrollbar";
import { RightOutlined } from "@ant-design/icons";

import "./TestVolumeTrendChart.css";

export const TrendChartCursor = ({ points, height }) => {
  if (!points?.length) return null;
  const { x } = points[0];
  return (
    <line
      x1={x}
      y1={0}
      x2={x}
      y2={height}
      stroke="var(--color-primary)"
      strokeWidth={1}
      strokeDasharray="4 4"
    />
  );
};

const TestVolumeTrendTooltip = ({
  active,
  payload,
  label,
  testColors,
  onViewDetails,
}) => {
  if (!active || !payload?.length || !label) return null;

  const formattedDate = moment(label).format("MMM D");
  const entries = orderBy(
    payload.filter((entry) => entry.value != null && entry.value !== undefined),
    ["value"],
    ["desc"],
  );

  const handleViewDetails = (event) => {
    event.stopPropagation();
    if (onViewDetails) {
      onViewDetails(label);
    }
  };

  return (
    <div className="TestVolumeTrendTooltip">
      <div className="TestVolumeTrendTooltip__Header">
        <span className="TestVolumeTrendTooltip__Title">
          Test count on
          {" "}
          {formattedDate}
        </span>
        <button
          type="button"
          className="TestVolumeTrendTooltip__ViewDetails"
          onClick={handleViewDetails}
        >
          Click dot to view details
          <RightOutlined />
        </button>
      </div>
      <StyledScrollbar
        autoHide
        className="TestVolumeTrendTooltip__Scrollbar"
      >
        <div className="TestVolumeTrendTooltip__List">
          {entries.map((entry) => {
            const color = testColors[entry.dataKey].color;
            return (
              <div key={entry.dataKey} className="TestVolumeTrendTooltip__Row">
                <div className="TestVolumeTrendTooltip__RowLabel">
                  <span
                    className="TestVolumeTrendTooltip__Dot"
                    style={{ backgroundColor: color }}
                  />
                  <span>{entry.dataKey}</span>
                </div>
                <span className="TestVolumeTrendTooltip__Value">
                  {String(entry.value).padStart(2, "0")}
                </span>
              </div>
            );
          })}
        </div>
      </StyledScrollbar>
    </div>
  );
};

export default TestVolumeTrendTooltip;
